const host = process.env.VUE_APP_BASE_URL;

export default {
  routes: {
    login: host + "/api/v2/login",
    logout: host + "/api/v2/logout",
    check: host + "/api/v2/check",
    firmaAvisoPrivacidad: host + "/api/v1/firmaAvisoPrivacidad",
    nuevaFirmaAvisoPrivacidad: host + "/api/v1/nuevaFirmaAvisoPrivacidad",
    detalleUsuario: host + "/api/v1/detalleUsuario",
    notificaciones: host + "/api/v1/notificaciones",
    ultimasNotificaciones: host + "/api/v1/ultimasNotificaciones",
    eliminarNotificacion: host + "/api/v1/eliminarNotificacion",
    rechazarSolicitud: host + "/api/v1/rechazarSolicitud",
    aprobarSolicitud: host + "/api/v1/aprobarSolicitud",
    detalleCompletoSolicitud: host + "/api/v1/detalleCompletoSolicitud",
    impresionDetalleCajaChica: host + "/api/v1/impresionDetalleCajaChica",
    impresionDetalleReposicion: host + "/api/v1/impresionDetalleReposicion",
    impresionDetalleGastosViaje: host + "/api/v1/impresionDetalleGastosViaje",
    nuevaSolicitudCajaChica: host + "/api/v1/nuevaSolicitudCajaChica",
    enviarSolicitudCajaChica: host + "/api/v1/enviarSolicitudCajaChica",
    movimientosCajaChica: host + "/api/v1/movimientosCajaChica",
    detalleSolicitudCajaChica: host + "/api/v1/detalleSolicitudCajaChica",
    nuevoIncrementoCajaChica: host + "/api/v1/nuevoIncrementoCajaChica",
    enviarIncrementoCajaChica: host + "/api/v1/enviarIncrementoCajaChica",
    detalleIncrementoCajaChica: host + "/api/v1/detalleIncrementoCajaChica",
    nuevaReposicionCajaChica: host + "/api/v1/nuevaReposicionCajaChica",
    reposicionesCajaChica: host + "/api/v1/reposicionesCajaChica",
    detalleReposicionCajaChica: host + "/api/v1/detalleReposicionCajaChica",
    nuevaSolicitudAnticipoViaje: host + "/api/v1/nuevaSolicitudAnticipoViaje",
    anticiposViaje: host + "/api/v1/anticiposViaje",
    detalleSolicitudAnticipoViaje:
      host + "/api/v1/detalleSolicitudAnticipoViaje",
    nuevoComprobanteAnticipoViaje:
      host + "/api/v1/nuevoComprobanteAnticipoViaje",
    eliminarComprobanteAnticipoViaje:
      host + "/api/v1/eliminarComprobanteAnticipoViaje",
    descargarDocumentoAnticipoViaje:
      host + "/api/v1/descargarDocumentoAnticipoViaje",
    nuevaComprobacionAnticipoViaje:
      host + "/api/v1/nuevaComprobacionAnticipoViaje",
    reembolsarAnticipoViaje: host + "/api/v1/reembolsarAnticipoViaje",
    actualizarConceptoDocumento: host + "/api/v1/actualizarConceptoDocumento",
    contaMovimientosCajaChica: host + "/api/v1/contaMovimientosCajaChica",
    contaDetalleMovimientoCajaChica:
      host + "/api/v1/contaDetalleMovimientoCajaChica",
    contaReposicionesCajaChica: host + "/api/v1/contaReposicionesCajaChica",
    contaDetalleReposicionCajaChica:
      host + "/api/v1/contaDetalleReposicionCajaChica",
    contaAnticiposViaje: host + "/api/v1/contaAnticiposViaje",
    contaDetalleSolicitudAnticipoViaje:
      host + "/api/v1/contaDetalleSolicitudAnticipoViaje",
    contaDescargarDocumentoAnticipoViaje:
      host + "/api/v1/contaDescargarDocumentoAnticipoViaje",
    contaActualizarConceptoDocumento:
      host + "/api/v1/contaActualizarConceptoDocumento",
    contaUsuarios: host + "/api/v1/contaUsuarios",
    contaFiltroMovimientosCajaChica:
      host + "/api/v1/contaFiltroMovimientosCajaChica",
    contaFiltroReposicionesCajaChica:
      host + "/api/v1/contaFiltroReposicionesCajaChica",
    contaFiltroAnticiposViaje: host + "/api/v1/contaFiltroAnticiposViaje",
    tesoMovimientosCajaChica: host + "/api/v1/tesoMovimientosCajaChica",
    tesoDetalleMovimientoCajaChica:
      host + "/api/v1/tesoDetalleMovimientoCajaChica",
    tesoReposicionesCajaChica: host + "/api/v1/tesoReposicionesCajaChica",
    tesoDetalleReposicionCajaChica:
      host + "/api/v1/tesoDetalleReposicionCajaChica",
    cancelarSolicitudCajaChica: host + "/api/v1/cancelarSolicitudCajaChica",
    usuarios: host + "/api/v1/usuarios",
    sincronizarUsuarios: host + "/api/v1/actualizarUsuarios",
    detalleCompletoUsuario: host + "/api/v1/detalleCompletoUsuario",
    actualizarEstadoUsuario: host + "/api/v1/actualizarEstadoUsuario",
    actualizarPermisosUsuario: host + "/api/v1/actualizarPermisosUsuario",
    actualizarCuentaNominaUsuario:
      host + "/api/v1/actualizarCuentaNominaUsuario",
    actualizarCuentaPersonalUsuario:
      host + "/api/v1/actualizarCuentaPersonalUsuario",
    obtenerCatalogosDisponibles: host + "/api/v1/obtenerCatalogosDisponibles",
    obtenerCatalogo: host + "/api/v1/obtenerCatalogo",
    obtenerCatalogoEstatus: host + "/api/v1/obtenerCatalogoEstatus",
    nuevoElementoCatalogo: host + "/api/v1/nuevoElementoCatalogo",
    actualizarElementoCatalogo: host + "/api/v1/actualizarElementoCatalogo",
    eliminarElementoCatalogo: host + "/api/v1/eliminarElementoCatalogo",
    adminMovimientosCajaChica: host + "/api/v1/adminMovimientosCajaChica",
    adminDetalleMovimientoCajaChica:
      host + "/api/v1/adminDetalleMovimientoCajaChica",
    adminReposicionesCajaChica: host + "/api/v1/adminReposicionesCajaChica",
    adminDetalleReposicionCajaChica:
      host + "/api/v1/adminDetalleReposicionCajaChica",
    adminAnticiposViaje: host + "/api/v1/adminAnticiposViaje",
    adminDetalleSolicitudAnticipoViaje:
      host + "/api/v1/adminDetalleSolicitudAnticipoViaje",
    adminDescargarDocumentoAnticipoViaje:
      host + "/api/v1/adminDescargarDocumentoAnticipoViaje",
    adminActualizarConceptoDocumento:
      host + "/api/v1/adminActualizarConceptoDocumento",
    adminImpresionDetalleCajaChica:
      host + "/api/v1/adminImpresionDetalleCajaChica",
    adminImpresionDetalleReposicion:
      host + "/api/v1/adminImpresionDetalleReposicion",
    adminImpresionDetalleGastosViaje:
      host + "/api/v1/adminImpresionDetalleGastosViaje",
    nuevoFlujoAprobacion: host + "/api/v1/nuevoFlujoAprobacion",
    flujosAprobacion: host + "/api/v1/flujosAprobacion",
    detalleFlujoAprobacion: host + "/api/v1/detalleFlujoAprobacion",
    actualizarFlujoAprobacion: host + "/api/v1/actualizarFlujoAprobacion",
    eliminarFlujoAprobacion: host + "/api/v1/eliminarFlujoAprobacion",
    procesosPendientes: host + "/api/v1/procesosPendientes",
    detalleProcesoPendiente: host + "/api/v1/detalleProcesoPendiente",
    actualizarEntradaProcesoPendiente:
      host + "/api/v1/actualizarEntradaProcesoPendiente",
    desbloquearProcesoPendiente: host + "/api/v1/desbloquearProcesoPendiente",
    enviarProcesoPendiente: host + "/api/v1/enviarProcesoPendiente",
    reenviarProcesoPendiente: host + "/api/v1/reenviarProcesoPendiente",
    verificarProcesoPendiente: host + "/api/v1/verificarProcesoPendiente",
    verificarBloqueoServicios: host + "/api/v1/verificarBloqueoServicios",
    bloquearServicios: host + "/api/v1/bloquearServicios",
    desbloquearServicios: host + "/api/v1/desbloquearServicios",
    amexSolicitudesList: host + "/api/solicitudes/amex/list",
    amexSolicitudesDetalle:
      host + "/api/solicitudes/amex/:idsolicitud_amex/detalle",
    amexProcesarPdf: host + "/api/solicitudes/amex/procesar/pdf",
    amexProcesarXML: host + "/api/solicitudes/amex/procesar/xml",
    amexProcesarCreate: host + "/api/solicitudes/amex/create",
    amexSolicitudAprobar:
      host + "/api/solicitudes/amex/:idsolicitud_amex/aprobar",
    amexSolicitudRechazar:
      host + "/api/solicitudes/amex/:idsolicitud_amex/rechazar",
    eliminarEdcAMEX: host + "/api/solicitudes/amex/edc/eliminar",
    amexEstadoCuentaPdf:
      host + "/api/solicitudes/amex/estadocuenta/pdf/:idpdf",
    amexSolcitudComprobacion:
      host + "/api/solicitudes/amex/comprobacion/create",
    amexComprobanteUpload: host + "/api/solicitudes/amex/comprobante/upload",
    amexComprobanteDelete: host + "/api/solicitudes/amex/comprobante/delete",
    amexComprobanteDescarga:
      host + "/api/solicitudes/amex/comprobante/descargar",
    amexComprobacionEnviar: host + "/api/solicitudes/amex/comprobacion/enviar",
    amexComprobacionDetalle: host + "/api/solicitudes/amex/comprobacion/:id",
    amexComprobacionAprobar:
      host + "/api/solicitudes/amex/comprobacion/:idsolicitud/aprobar",
    amexComprobacionRechazar:
      host + "/api/solicitudes/amex/comprobacion/:idsolicitud/rechazar",
    impresionDetalleSolicitudComprobacionAMEX:
      host + "/api/impresionDetalleSolicitudComprobacionAMEX",
    impresionDetalleSolicitudAMEX:
      host + "/api/impresionDetalleSolicitudAMEX",
    backVersion: host + "/api/backVersion",
    representacionSolicitudesCreate: host + "/api/gastos/representacion",
    representacionSolicitudesList: host + "/api/gastos/representacion/list",
    representacionSolicitudesDetalle: host + "/api/gastos/representacion/:id",
    representacionSolicitudesUpdate: host + "/api/gastos/representacion/update",
    representacionSolicitudesAprobar:
      host + "/api/solicitudes/representacion/:idsolicitud/aprobar",
    representacionSolicitudesRechazar:
      host + "/api/solicitudes/representacion/:idsolicitud/rechazar",
    representacionComprobacionSolicitudesList:
      host + "/api/solicitudes/comprobacion-representacion/list",
    representacionProcesarXML:
      host + "/api/solicitudes/comprobacion-representacion/procesar/xml",
    representacionComprobacionSolicitudCreate:
      host + "/api/solicitudes/comprobacion-representacion",
    representacionComprobacionSolicitudDetalle:
      host + "/api/solicitudes/comprobacion-representacion/:id",
    representacionComprobacionSolicitudesAprobar:
      host +
      "/api/solicitudes/comprobacion-representacion/:idsolicitud/aprobar",
    representacionComprobacionSolicitudesRechazar:
      host +
      "/api/solicitudes/comprobacion-representacion/:idsolicitud/rechazar",
    impresionDetalleSolicitudComprobacionRepresentacion:
      host + "/api/impresionDetalleSolicitudComprobacionRepresentacion",
    impresionDetalleSolicitudRepresentacion:
      host + "/api/impresionDetalleSolicitudRepresentacion",
    descargarComprobantesComprobacionRepresentacion:
      host + "/api/solicitudes/comprobacion-representacion/:id/comprobantes",
    descargarComprobantesComprobacionRepresentacionByComprobanteId:
      host +
      "/api/solicitudes/comprobacion-representacion/:idsol/comprobantes/:id",
    descargarComprobantesComprobacionAMEX:
      host + "/api/solicitudes/amex/comprobacion/:idsolicitud/comprobantes",
    updateConcepto: host + "/api/conceptos/update",
    getConceptos: host + "/api/conceptos/list"
  },
  apiBase: host
};
